/**
 * Survives logout so pending offline sync (timesheets, photos, etc.) can be
 * restored after the user signs back in with a fresh token.
 */
export const OFFLINE_SYNC_QUEUE_BACKUP_KEY = "safetywise:offlineSyncQueueBackup";

export const backupOfflineSyncQueue = (queueList) => {
	try {
		if (!Array.isArray(queueList) || queueList.length === 0) {
			return;
		}
		localStorage.setItem(OFFLINE_SYNC_QUEUE_BACKUP_KEY, JSON.stringify(queueList));
	} catch (_e) {
		// Best-effort: never block logout on storage errors.
	}
};

export const readOfflineSyncQueueBackup = () => {
	try {
		const raw = localStorage.getItem(OFFLINE_SYNC_QUEUE_BACKUP_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
	} catch (_e) {
		return null;
	}
};

export const clearOfflineSyncQueueBackup = () => {
	try {
		localStorage.removeItem(OFFLINE_SYNC_QUEUE_BACKUP_KEY);
	} catch (_e) {
		// ignore
	}
};
